// eslint-disable-next-line @typescript-eslint/no-unused-vars
const SPEEDSIZE_CLIENT_ID = process.env.NEXT_PUBLIC_SPEEDSIZE_CLIENT_ID;
export const SPEEDSIZE_CDN = 'https://cdn.speedsize.com';

// Old Domain
export const S3_URI =
  'https://s3.amazonaws.com/public-web-assets.ultrahuman.com';

export const UH_STATIC_URL = 'https://public-web-assets.uh-static.com';

// Old Domain
export const S3_PUBLIC_ASSETS_URL = 'https://public-assets.ultrahuman.com';

export const getAssetUrl = (input: string) => {
  return `${UH_STATIC_URL}${input}`;
}

export const getCompressedAssetUrl = (input: string) => {
  return `${SPEEDSIZE_CDN}/${process.env.NEXT_PUBLIC_SPEEDSIZE_CLIENT_ID}/${UH_STATIC_URL}${input}`;
}